import type { ISerialize } from '@/objects/ISerialize';

export class SignalrRaceContestantTimeSubscribeParameters implements ISerialize {
    public EventID: number;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { EventID?: number }) {
        this.EventID = values.EventID ?? 0;
    }

    public serialize(): string {
        return '{' + `"EventID": ${JSON.stringify(this.EventID)}` + '}';
    }

    /**
     * Creates an instance of SignalrRaceContestantTimeSubscribeParameters from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { EventID?: number }): SignalrRaceContestantTimeSubscribeParameters {
        return new SignalrRaceContestantTimeSubscribeParameters(values);
    }

    public static _FromServerJson(json: any): SignalrRaceContestantTimeSubscribeParameters {
        return new SignalrRaceContestantTimeSubscribeParameters({ EventID: json.EventID });
    }

    /**
     * Creates an instance of SignalrRaceContestantTimeSubscribeParameters from another instance of SignalrRaceContestantTimeSubscribeParameters.
     * @param other The SignalrRaceContestantTimeSubscribeParameters you want to clone
     * @returns A cloned SignalrRaceContestantTimeSubscribeParameters
     */
    public static FromOther(other: SignalrRaceContestantTimeSubscribeParameters): SignalrRaceContestantTimeSubscribeParameters {
        return SignalrRaceContestantTimeSubscribeParameters._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return SignalrRaceContestantTimeSubscribeParameters.FromOther(this);
    }

    static NAME_OF_CLASS = 'SignalrRaceContestantTimeSubscribeParameters';
}
